var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeightage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#008EF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.995 5C7.685 5 4.175 8.41 4.005 12.69C4.005 12.86 4.145 13 4.315 13H5.215C5.375 13 5.505 12.87 5.505 12.71C5.655 9.25 8.515 6.5 11.995 6.5C15.475 6.5 18.335 9.26 18.485 12.71C18.485 12.87 18.615 13 18.775 13H19.675C19.845 13 19.985 12.86 19.985 12.69C19.815 8.42 16.305 5 11.995 5Z",
    fill: "#008EF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.825 14.66C13.825 15.66 13.025 16.46 12.025 16.46C11.025 16.46 10.225 15.66 10.225 14.66C10.225 14 10.585 13.42 11.115 13.11C11.215 13.05 11.275 12.96 11.275 12.85V9.56996C11.275 9.36996 11.435 9.20996 11.635 9.20996H12.415C12.615 9.20996 12.775 9.36996 12.775 9.56996V12.85C12.775 12.96 12.845 13.06 12.935 13.11C13.465 13.42 13.825 13.99 13.825 14.66Z",
    fill: "#008EF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.99,
    height: 11.46,
    fill: "white",
    transform: "translate(4.005 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightage);
export default __webpack_public_path__ + "static/media/weightage.80b5a022bcd87fe69f8a3f0aa35ec8ee.svg";
export { ForwardRef as ReactComponent };